var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonCircleLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 21.9067C23.6836 21.9067 26.6669 18.9939 26.6669 15.3978C26.6669 11.8016 23.6836 8.88892 20.0003 8.88892C16.3169 8.88892 13.3336 11.8016 13.3336 15.3978C13.3336 18.9939 16.3169 21.9067 20.0003 21.9067Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 32.265C6.66699 27.9366 15.5503 25.7561 20.0003 25.7561C24.4503 25.7561 33.3336 27.9366 33.3336 32.265C33.3336 32.265 28.5001 38.0001 20.0003 38.0001C11.5005 38.0001 6.66699 32.265 6.66699 32.265Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 21.9067C23.6836 21.9067 26.6669 18.9939 26.6669 15.3978C26.6669 11.8016 23.6836 8.88892 20.0003 8.88892C16.3169 8.88892 13.3336 11.8016 13.3336 15.3978C13.3336 18.9939 16.3169 21.9067 20.0003 21.9067Z",
    stroke: "black",
    strokeWidth: 1.44445
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 32.265C6.66699 27.9366 15.5503 25.7561 20.0003 25.7561C24.4503 25.7561 33.3336 27.9366 33.3336 32.265C33.3336 32.265 28.5001 38.0001 20.0003 38.0001C11.5005 38.0001 6.66699 32.265 6.66699 32.265Z",
    stroke: "black",
    strokeWidth: 1.44445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircleLg);
export default __webpack_public_path__ + "static/media/person-circle-lg.aef82ba4ef7d4ae63cabfc0efc517845.svg";
export { ForwardRef as ReactComponent };